'use client';

import type { ProductQuery } from '@packages/gql/generated/shopping/graphql';
import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useParams, useSearchParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export const PageRedirects = ({
  product,
  clientSideRedirect,
}: {
  product: ProductQuery['product'];
  clientSideRedirect: string | null;
}) => {
  const params = useParams<{ slug: string; akl?: string }>();
  const searchParams = useSearchParams();
  const { language, localizeUrl } = useI18n();
  const { replace } = useRouter();

  // if sku in URL differs to the product sku it has to be the default product -> redirect to default sku [NJS-979]
  // has to be client side because of seo needs
  // useEffect(() => {
  //   if (product) {
  //     // it should redirect to slugged URL if the URL has no slug -> /p/AKLBB1337
  //     if (!params?.akl) {
  //       window.history.replaceState(
  //         null,
  //         '',
  //         localizeUrl(
  //           `/p/${product.akl}${searchParams?.size ? `?${searchParams.toString()}` : ''}`,
  //           language,
  //         ),
  //       );
  //     } else if (searchParams?.get('sku') && !product.sku.startsWith(searchParams.get('sku')!)) {
  //       /* it should redirect to default sku if search sku is invalid */
  //       const newSearchParams = new URLSearchParams(searchParams?.toString());
  //       newSearchParams.set('sku', product.sku);
  //       window.history.replaceState(
  //         null,
  //         '',
  //         localizeUrl(`/p/${product.akl}?${newSearchParams.toString()}`, language),
  //       );
  //     }
  //   }
  // }, [product, params?.akl, localizeUrl, searchParams, language]);

  // if sku in URL differs to the product sku it has to be the default product -> redirect to default sku [NJS-979]
  // has to be client side because of seo needs
  // TODO -> this must be included in the API and removed here
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    if (product) {
      // product is needed for this operations
      const searchParamsForOperation = clientSideRedirect
        ? new URLSearchParams(clientSideRedirect.split('?')[1])
        : searchParams;
      const skuFromSearchParams = searchParamsForOperation?.get('sku');

      const hasNoSku = !skuFromSearchParams;
      const hasDifferentSku = skuFromSearchParams !== product.sku;
      const hasSlugThatNeedsToBeRemoved = params?.slug && params?.akl;

      if (hasNoSku || hasDifferentSku || hasSlugThatNeedsToBeRemoved) {
        const paramSku =
          skuFromSearchParams !== product.sku // this also covers the missing sku case, as `product.sku` should never be empty
            ? product.sku
            : skuFromSearchParams;

        // searchParamsForOperation?.set('sku', paramSku);
        // sku has to be the first
        const searchParamsWithSKU = new URLSearchParams({ sku: paramSku });
        // then add all the others
        // must be added this way because ...Object.entries(searchParams) would remove multiple params with the same key
        searchParamsForOperation?.forEach((value, key) => {
          if (key === 'sku') return;

          searchParamsWithSKU.append(key, value);
        });
        // searchParamsWithSKU.toString is not needed because the template literal calls toString
        replace(
          localizeUrl(
            `${clientSideRedirect ? clientSideRedirect.split('?')[0] : `/p/${product.akl}`}?${searchParamsWithSKU}`,
            language,
          ),
        );
      }
    } else if (clientSideRedirect) {
      const localizedURL = localizeUrl(clientSideRedirect, language);

      if (localizedURL !== clientSideRedirect) {
        replace(localizedURL);
      }
    }
  }, [product, localizeUrl, searchParams, language, params, clientSideRedirect, replace]);

  return null;
};
